export const generateId = () => {
    const id = Math.ceil(Math.random() * 100000)
    return id
}